var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.processing,
      "bg-color": "#ffffff",
      "z-index": "501",
      "opacity": "0.6"
    }
  }, [_c('h6', {
    staticClass: "mb-1 mt-1 text-center"
  }, [_vm._v("登入")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form', {
    staticClass: "av-tooltip tooltip-label-bottom",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "電子郵件"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("密碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('b-button', {
    staticClass: "btn-block primary-button login-button",
    attrs: {
      "size": "lg",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 登入 ")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('router-link', {
    staticClass: "float-left text-bold register-highlight",
    attrs: {
      "to": {
        path: '/' + _vm.$route.params.org_code + '/liff/register'
      }
    }
  }, [_vm._v("註冊成為會員")]), _c('router-link', {
    staticClass: "float-right",
    attrs: {
      "to": {
        path: '/' + _vm.$route.params.org_code + '/liff/forgotpassword'
      }
    }
  }, [_vm._v("忘記密碼了嗎？")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }